import { render, staticRenderFns } from "./Birthday.vue?vue&type=template&id=f312578a&scoped=true&"
import script from "./Birthday.vue?vue&type=script&lang=js&"
export * from "./Birthday.vue?vue&type=script&lang=js&"
import style0 from "./Birthday.vue?vue&type=style&index=0&id=f312578a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f312578a",
  null
  
)

export default component.exports